import { render, staticRenderFns } from "./AveragePaxPerVehicleType.vue?vue&type=template&id=e264400c&scoped=true&"
import script from "./AveragePaxPerVehicleType.vue?vue&type=script&lang=js&"
export * from "./AveragePaxPerVehicleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e264400c",
  null
  
)

export default component.exports